import React, { useState, useEffect, useRef } from 'react';
import section4Video from './section4.mp4';
import './Section4.css';

const Section4 = () => {
  const [textFadeProgress, setTextFadeProgress] = useState(0);
  const [videoFadeProgress, setVideoFadeProgress] = useState(1);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const containerRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const rect = container.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      // Text + Video fade in as section enters (rect.top: viewportHeight -> 0)
      if (rect.top > 0) {
        const progress = Math.max(0, Math.min(1, 1 - (rect.top / viewportHeight)));
        setTextFadeProgress(progress);
        setVideoFadeProgress(progress);
      }
      // Video fades out as section exits (rect.top: 0 -> -viewportHeight)
      else if (rect.top <= 0 && rect.top > -viewportHeight) {
        setTextFadeProgress(1);
        const progress = 1 + (rect.top / viewportHeight);
        setVideoFadeProgress(Math.max(0, Math.min(1, progress)));
      }
      // Section completely scrolled past
      else {
        setTextFadeProgress(1);
        setVideoFadeProgress(0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleVideoReady = () => {
    setIsVideoLoading(false);
  };

  // Start video autoplay when component mounts
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(err => {
        console.log('Autoplay prevented:', err);
      });
    }
  }, []);

  return (
    <section className="section4-container" ref={containerRef}>
      <div className="section4-content">

        {/* Left Side: Video */}
        <div className="section4-left">
          <video
            ref={videoRef}
            className="section4-video"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            onLoadedData={handleVideoReady}
            onCanPlay={handleVideoReady}
            onError={handleVideoReady}
            src={section4Video}
            style={{
              opacity: videoFadeProgress
            }}
          />
          {isVideoLoading && (
            <div className="section4-video-loader" aria-live="polite">
              <div className="section4-video-spinner" />
              <span className="section4-video-loader-text">Loading demo...</span>
            </div>
          )}
        </div>

        {/* Right Side: Text Content */}
        <div className="section4-right">
          <div
            className="section4-text-wrapper"
            style={{
              opacity: textFadeProgress
            }}
          >
            <h2 className="section4-title">Digital Assets Library</h2>
            <p className="section4-body">
            Encapsulate complex design requirements into one-click styles. Select a preset, and the engine immediately calculates and applies the overarching aesthetic to the underlying geometry.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Section4;
